export const routes = (prefix) => [
    {
        path: `/${prefix}/geographic/counties`,
        name: `${prefix}.geographic.counties.index`,
        component: () => import('./county/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.geographic.counties.index`,
                PageDescription: "County Listing/Create",
            }
        }
    },
    {
        path: `/${prefix}/geographic/locations`,
        name: `${prefix}.geographic.locations.index`,
        component: () => import('./location/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.geographic.locations.index`,
                PageDescription: "Location Listing/Create",
            }
        }
    },
    {
        path: `/${prefix}/geographic/sub-locations`,
        name: `${prefix}.geographic.sub-locations.index`,
        component: () => import('./sub-location/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.geographic.sub-locations.index`,
                PageDescription: "Sub-location Listing/Create",
            }
        }
    },
]; 
